module.exports = __webpack_public_path__ + "assets/img/edit_property_change_output_type.1214e2b4.png";